<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h4>Agradecemos a todas las instituciones cuyas colecciones se reproducen en esta exposición y nos permiten contar la historia de nuestro país.</h4>
    <ul>
      <li>Antigüedades Rodrigo Rivero Lake</li>
      <li>Basílica de Guadalupe, ciudad de México</li>
      <li>Biblioteca conmemorativa Howard-Tilton, Universidad de Tulane.</li>
      <li>Biblioteca del Congreso, Washington DC</li>
      <li>Biblioteca del Niño Mexicano</li>
      <li>Biblioteca del Rijksmuseum</li>
      <li>Biblioteca Laurenciana de Florencia</li>
      <li>Biblioteca Nacional de Antropología e Historia, INAH, México</li>
      <li>Biblioteca Nacional de España</li>
      <li>Biblioteca Nacional de Francia</li>
      <li>Biblioteca Newberry, Chicago</li>
      <li>Biblioteca Pública de Nueva York</li>
      <li>Biblioteca Vaticana</li>
      <li>Catedral Metropolitana. Ciudad de México</li>
      <li>Colección Hunter, Universidad de Glasgow</li>
      <li>Fondo Antiguo de la Biblioteca de la Universidad de Sevilla</li>
      <li>Fototeca Nacional</li>
      <li>John Carter, Universidad de Brown.</li>
      <li>Latinoamericana Benson, Universidad de Texas</li>
      <li>Museo Amparo</li>
      <li>Museo Británico</li>
      <li>Museo de América</li>
      <li>Museo de Arte Religioso</li>
      <li>Museo de Historia Mexicana</li>
      <li>Museo de la Basílica de Guadalupe</li>
      <li>Museo de la Evangelización "Ex Convento de Huejotzingo"</li>
      <li>Museo del Estado “Casa de Alfeñique”</li>
      <li>Museo del Prado</li>
      <li>Museo del Virreinato de San Luis Potosí</li>
      <li>Museo José Luis Bello y Zetina</li>
      <li>Museo Metropolitano de New York</li>
      <li>Museo Nacional de Antropología</li>
      <li>Museo Nacional de Arte INBA</li>
      <li>Museo Nacional de Historia</li>
      <li>Museo Nacional de las Intervenciones</li>
      <li>Museo Nacional del Virreinato</li>
      <li>Museo Regional “Casa de Alfeñique”</li>
      <li>Museo Soumaya</li>
      <li>Museo y Archivo Histórico Casa de Morelos</li>
      <li>San Pedro Museo de Arte</li>
      <li>Estado de Puebla/Secretaría de Cultura/OPD Museos Puebla/Museo "José Luis Bello y González"</li>
      <li>Biblioteca Palafoxiana</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "Sala1m1",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
